import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Output, Input, inject, ElementRef, ViewChild, HostListener, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as i3 from '@spartacus/core';
import { isNotNullable, FeatureConfigService, useFeatureStyles, I18nModule, FeaturesConfigModule, provideDefaultConfig } from '@spartacus/core';
import * as i1 from '@spartacus/storefront';
import { ICON_TYPE, BREAKPOINT, DIALOG_TYPE, ProductImagesComponent, CarouselModule, IconModule, KeyboardFocusModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { BehaviorSubject, Subscription, merge, combineLatest, fromEvent, of } from 'rxjs';
import { filter, map, switchMap, tap, distinctUntilChanged, shareReplay, take } from 'rxjs/operators';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function ProductImageZoomThumbnailsComponent_ng_container_0_cx_carousel_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 3);
  }
  if (rf & 2) {
    const thumbs_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵnextContext();
    const thumb_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("items", thumbs_r1)("hideIndicators", false)("template", thumb_r2);
  }
}
function ProductImageZoomThumbnailsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImageZoomThumbnailsComponent_ng_container_0_cx_carousel_1_Template, 1, 3, "cx-carousel", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const thumbs_r1 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumbs_r1.length);
  }
}
function ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 6);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("focus", function ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_0_Template_cx_media_focus_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const item_r4 = i0.ɵɵnextContext().item;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.openImage(item_r4.container));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 3, ctx_r4.isActive(item_r4.container)));
    i0.ɵɵproperty("container", item_r4.container);
  }
}
function ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 7);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("focus", function ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_1_Template_cx_media_focus_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const item_r4 = i0.ɵɵnextContext().item;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.openImage(item_r4.container));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 3, ctx_r4.isActive(item_r4.container)));
    i0.ɵɵproperty("container", item_r4.container);
  }
}
function ProductImageZoomThumbnailsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_0_Template, 2, 5, "cx-media", 4)(1, ProductImageZoomThumbnailsComponent_ng_template_2_cx_media_1_Template, 2, 5, "cx-media", 5);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yCarouselArrowKeysNavigation");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yCarouselArrowKeysNavigation");
  }
}
const _c0 = ["defaultImage"];
const _c1 = ["zoomContainer"];
const _c2 = ["zoomedImage"];
const _c3 = ["zoomButton"];
function ProductImageZoomViewComponent_ng_container_0_div_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ProductImageZoomViewComponent_ng_container_0_div_1_button_2_Template_button_click_0_listener() {
      const previousProduct_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.openImage(previousProduct_r2.container));
    });
    i0.ɵɵelement(3, "cx-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "productImageZoomDialog.previousSlide"))("title", i0.ɵɵpipeBind1(2, 5, "productImageZoomDialog.previousSlide"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconType.CARET_LEFT);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_cx_media_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 18, 0);
    i0.ɵɵlistener("loaded", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_cx_media_1_Template_cx_media_loaded_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onImageLoad());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const main_r5 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵproperty("container", main_r5);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19, 1)(2, "cx-media", 20, 2);
    i0.ɵɵlistener("mousemove", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template_cx_media_mousemove_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.pointerMove($event));
    })("touchmove", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template_cx_media_touchmove_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.touchMove($event));
    })("touchend", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template_cx_media_touchend_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.clearTouch());
    })("loaded", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template_cx_media_loaded_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onImageLoad());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const main_r5 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", main_r5);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_cx_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 23);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("type", ctx_r2.iconType.SEARCH_PLUS);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_cx_icon_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 23);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("type", ctx_r2.iconType.SEARCH_MINUS);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21, 3);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵlistener("click", function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.zoom());
    });
    i0.ɵɵtemplate(6, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_cx_icon_6_Template, 1, 1, "cx-icon", 22)(7, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_cx_icon_7_Template, 1, 1, "cx-icon", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("title", ctx_r2.isZoomed ? i0.ɵɵpipeBind1(2, 4, "common.zoomOut") : i0.ɵɵpipeBind1(3, 6, "common.zoomIn"));
    i0.ɵɵattribute("aria-label", ctx_r2.isZoomed ? i0.ɵɵpipeBind1(4, 8, "common.zoomOut") : i0.ɵɵpipeBind1(5, 10, "common.zoomIn"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r2.isZoomed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isZoomed);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_cx_media_1_Template, 2, 1, "cx-media", 15)(2, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_div_2_Template, 4, 1, "div", 16)(3, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_button_3_Template, 8, 12, "button", 17);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isZoomed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isZoomed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 3, ctx_r2.imageLoaded));
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_cx_media_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 25, 0);
  }
  if (rf & 2) {
    const main_r5 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵproperty("container", main_r5);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19, 1)(2, "cx-media", 26, 2);
    i0.ɵɵlistener("mousemove", function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_div_2_Template_cx_media_mousemove_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.pointerMove($event));
    })("touchmove", function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_div_2_Template_cx_media_touchmove_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.touchMove($event));
    })("touchend", function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_div_2_Template_cx_media_touchend_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.clearTouch());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const main_r5 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", main_r5);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_cx_media_1_Template, 2, 1, "cx-media", 24)(2, ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_div_2_Template, 4, 1, "div", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isZoomed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isZoomed);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ProductImageZoomViewComponent_ng_container_0_div_1_button_7_Template_button_click_0_listener() {
      const nextProduct_r10 = i0.ɵɵrestoreView(_r9).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.openImage(nextProduct_r10.container));
    });
    i0.ɵɵelement(3, "cx-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "productImageZoomDialog.nextSlide"))("title", i0.ɵɵpipeBind1(2, 5, "productImageZoomDialog.nextSlide"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconType.CARET_RIGHT);
  }
}
function ProductImageZoomViewComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtemplate(2, ProductImageZoomViewComponent_ng_container_0_div_1_button_2_Template, 4, 7, "button", 9);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProductImageZoomViewComponent_ng_container_0_div_1_div_4_Template, 5, 5, "div", 10)(5, ProductImageZoomViewComponent_ng_container_0_div_1_ng_container_5_Template, 3, 2, "ng-container", 11);
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtemplate(7, ProductImageZoomViewComponent_ng_container_0_div_1_button_7_Template, 4, 7, "button", 9);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const thumbs_r11 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r2.getPreviousProduct(thumbs_r11)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yKeyboardAccessibleZoom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yKeyboardAccessibleZoom");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 6, ctx_r2.getNextProduct(thumbs_r11)));
  }
}
function ProductImageZoomViewComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImageZoomViewComponent_ng_container_0_div_1_Template, 9, 8, "div", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.thumbnails$));
  }
}
const _c4 = ["expandButton"];
function ProductImageZoomTriggerComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3, 0);
    i0.ɵɵlistener("click", function ProductImageZoomTriggerComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerZoom());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelement(4, "cx-icon", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "productImageZoomTrigger.expand"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconType.EXPAND_ARROWS);
  }
}
function ProductImageZoomTriggerComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5, 0);
    i0.ɵɵlistener("click", function ProductImageZoomTriggerComponent_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerZoom());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "cx-icon", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "productImageZoomTrigger.expand"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconType.EXPAND_ARROWS);
  }
}
const _c5 = a0 => ({
  product: a0
});
function ProductImageZoomProductImagesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cx-media", 2);
    i0.ɵɵlistener("click", function ProductImageZoomProductImagesComponent_ng_container_0_Template_cx_media_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerZoom(true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "cx-product-image-zoom-trigger", 3);
    i0.ɵɵlistener("dialogClose", function ProductImageZoomProductImagesComponent_ng_container_0_Template_cx_product_image_zoom_trigger_dialogClose_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerZoom(false));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const main_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("container", main_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("expandImage", ctx_r1.expandImage.value)("galleryIndex", ctx_r1.selectedIndex);
  }
}
function ProductImageZoomProductImagesComponent_ng_container_2_ng_container_1_cx_carousel_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 5);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const product_r4 = i0.ɵɵnextContext().ngIf;
    const thumbs_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵnextContext();
    const thumb_r6 = i0.ɵɵreference(5);
    i0.ɵɵproperty("items", thumbs_r5)("hideIndicators", false)("template", thumb_r6);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 4, "carousel.carouselForProduct", i0.ɵɵpureFunction1(7, _c5, product_r4.name)));
  }
}
function ProductImageZoomProductImagesComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImageZoomProductImagesComponent_ng_container_2_ng_container_1_cx_carousel_1_Template, 2, 9, "cx-carousel", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const thumbs_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumbs_r5.length);
  }
}
function ProductImageZoomProductImagesComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImageZoomProductImagesComponent_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.product$));
  }
}
function ProductImageZoomProductImagesComponent_ng_template_4_cx_media_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 8);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("focus", function ProductImageZoomProductImagesComponent_ng_template_4_cx_media_0_Template_cx_media_focus_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const item_r8 = i0.ɵɵnextContext().item;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openImage(item_r8.container));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().item;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 3, ctx_r1.isActive(item_r8.container)));
    i0.ɵɵproperty("container", item_r8.container);
  }
}
function ProductImageZoomProductImagesComponent_ng_template_4_cx_media_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 9);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("focus", function ProductImageZoomProductImagesComponent_ng_template_4_cx_media_1_Template_cx_media_focus_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const item_r8 = i0.ɵɵnextContext().item;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openImage(item_r8.container));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().item;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 3, ctx_r1.isActive(item_r8.container)));
    i0.ɵɵproperty("container", item_r8.container);
  }
}
function ProductImageZoomProductImagesComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductImageZoomProductImagesComponent_ng_template_4_cx_media_0_Template, 2, 5, "cx-media", 6)(1, ProductImageZoomProductImagesComponent_ng_template_4_cx_media_1_Template, 2, 5, "cx-media", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yCarouselArrowKeysNavigation");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yCarouselArrowKeysNavigation");
  }
}
let ProductImageZoomThumbnailsComponent = /*#__PURE__*/(() => {
  class ProductImageZoomThumbnailsComponent {
    constructor() {
      this.mainMediaContainer = new BehaviorSubject({});
      this.productImage = new EventEmitter();
      this.subscription = new Subscription();
      // Intentional empty constructor
    }
    ngOnInit() {
      this.subscription.add(this.activeThumb.subscribe(image => {
        this.mainMediaContainer.next(image);
      }));
    }
    openImage(image) {
      this.mainMediaContainer.next(image);
      if (typeof image.zoom?.galleryIndex === 'number') {
        this.productImage.emit({
          image,
          index: image.zoom.galleryIndex
        });
      }
    }
    isActive(thumbnail) {
      return this.mainMediaContainer.asObservable().pipe(filter(isNotNullable), map(container => {
        return container.zoom?.url && thumbnail.zoom?.url && container.zoom.url === thumbnail.zoom.url;
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function ProductImageZoomThumbnailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomThumbnailsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductImageZoomThumbnailsComponent,
        selectors: [["cx-product-image-zoom-thumbnails"]],
        inputs: {
          thumbs$: "thumbs$",
          activeThumb: "activeThumb"
        },
        outputs: {
          productImage: "productImage"
        },
        standalone: false,
        decls: 4,
        vars: 3,
        consts: [["thumb", ""], [4, "ngIf"], ["class", "thumbs", "itemWidth", "70px", 3, "items", "hideIndicators", "template", 4, "ngIf"], ["itemWidth", "70px", 1, "thumbs", 3, "items", "hideIndicators", "template"], ["cxFocusableCarouselItem", "", "tabindex", "0", 3, "container", "is-active", "focus", 4, "cxFeature"], ["tabindex", "0", 3, "container", "is-active", "focus", 4, "cxFeature"], ["cxFocusableCarouselItem", "", "tabindex", "0", 3, "focus", "container"], ["tabindex", "0", 3, "focus", "container"]],
        template: function ProductImageZoomThumbnailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProductImageZoomThumbnailsComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, ProductImageZoomThumbnailsComponent_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.thumbs$));
          }
        },
        dependencies: [i1.CarouselComponent, i1.FocusableCarouselItemDirective, i2.NgIf, i1.MediaComponent, i3.FeatureDirective, i2.AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProductImageZoomThumbnailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomViewComponent = /*#__PURE__*/(() => {
  class ProductImageZoomViewComponent {
    get defaultImage() {
      return this._defaultImage;
    }
    set defaultImage(el) {
      if (el) {
        this._defaultImage = el;
        this.defaultImageReady.next(true);
      }
    }
    get zoomImage() {
      return this._zoomImage;
    }
    set zoomImage(el) {
      if (el) {
        this._zoomImage = el;
        this.zoomReady.next(true);
      }
    }
    constructor(currentProductService, renderer, cdRef, breakpointService) {
      this.currentProductService = currentProductService;
      this.renderer = renderer;
      this.cdRef = cdRef;
      this.breakpointService = breakpointService;
      this.iconType = ICON_TYPE;
      this.mainMediaContainer = new BehaviorSubject(null);
      this.defaultImageReady = new BehaviorSubject(false);
      this.zoomReady = new BehaviorSubject(false);
      this.imageLoaded = new BehaviorSubject(false);
      this.subscription = new Subscription();
      this.mainMediaContainer$ = this.mainMediaContainer.asObservable();
      this.defaultImageReady$ = this.defaultImageReady.asObservable();
      this.zoomReady$ = this.zoomReady.asObservable();
      this.featureConfigService = inject(FeatureConfigService);
      this.activeThumb = new EventEmitter();
      this.defaultImageClickHandler$ = this.defaultImageReady$.pipe(filter(Boolean), switchMap(_ => merge(...this.clickOrDoubleClick(this.defaultImage)).pipe(tap(() => this.zoom()))));
      this.zoomImageClickHandler$ = this.zoomReady$.pipe(filter(Boolean), switchMap(_ => merge(...this.clickOrDoubleClick(this.zoomImage)).pipe(tap(() => this.zoom()))));
      this.startCoords = null;
      this.left = 0;
      this.top = 0;
      this.isZoomed = false;
      this.product$ = this.currentProductService.getProduct().pipe(filter(isNotNullable), distinctUntilChanged(), tap(p => {
        if (this.galleryIndex) {
          const image = Array.isArray(p.images?.GALLERY) ? p.images?.GALLERY.find(img => img.zoom?.galleryIndex === this.galleryIndex) : p.images?.GALLERY;
          this.mainMediaContainer.next(image || null);
        } else {
          this.mainMediaContainer.next(p.images?.PRIMARY ? p.images.PRIMARY : {});
        }
      }), shareReplay(1));
      this.thumbnails$ = this.product$.pipe(map(p => this.createThumbs(p)), shareReplay(1));
      this.mainImage$ = combineLatest([this.product$, this.mainMediaContainer$]).pipe(map(([, container]) => container));
      useFeatureStyles('a11yKeyboardAccessibleZoom');
      useFeatureStyles('a11yCroppedFocusRing');
    }
    ngOnInit() {
      this.subscription.add(this.defaultImageClickHandler$.subscribe());
      this.subscription.add(this.zoomImageClickHandler$.subscribe());
    }
    openImage(item) {
      this.mainMediaContainer.next(item);
      this.activeThumb.emit(item);
    }
    /** find the index of the main media in the list of media */
    getActive() {
      if (Array.isArray(this.mainMediaContainer.value)) {
        return this.mainMediaContainer.value[0].thumbnail?.galleryIndex || 0;
      }
      return this.mainMediaContainer?.value?.thumbnail?.galleryIndex || 0;
    }
    getPreviousProduct(thumbs) {
      const active = this.getActive();
      if (active === 0) {
        return thumbs[active];
      }
      return thumbs[active - 1];
    }
    getNextProduct(thumbs) {
      const active = this.getActive();
      if (active === thumbs.length - 1) {
        return thumbs[active];
      }
      return thumbs[active + 1];
    }
    /**
     * Zoom in or out of the image
     */
    zoom() {
      this.isZoomed = !this.isZoomed;
      this.startCoords = null;
      this.left = 0;
      this.top = 0;
      this.cdRef.markForCheck();
      // TODO: (CXSPA-7492) - Remove feature flag next major release.
      if (this.featureConfigService.isEnabled('a11yKeyboardAccessibleZoom')) {
        this.imageLoaded.next(false);
        this.imageLoaded.pipe(filter(Boolean), take(1)).subscribe(() => {
          setTimeout(() => {
            this.zoomButton.nativeElement.focus();
          });
        });
      }
    }
    /**
     * Touch screen image pan
     *
     * @param event
     */
    touchMove(event) {
      const touch = event.touches[0] || event.changedTouches[0];
      const boundingRect = this.zoomedImage?.nativeElement?.getBoundingClientRect();
      const imageElement = this.zoomedImage?.nativeElement?.firstChild;
      if (!this.startCoords) {
        this.startCoords = {
          x: touch.clientX,
          y: touch.clientY
        };
      }
      this.left += touch.clientX - this.startCoords.x;
      this.top += touch.clientY - this.startCoords.y;
      this.moveImage(this.left, this.top, boundingRect, imageElement);
      this.startCoords = {
        x: touch.clientX,
        y: touch.clientY
      };
    }
    /**
     * Clears touch location
     */
    clearTouch() {
      this.startCoords = null;
    }
    /**
     * Pointer image pan
     *
     * @param event
     */
    pointerMove(event) {
      const boundingRect = this.zoomedImage.nativeElement.getBoundingClientRect();
      const imageElement = this.zoomedImage.nativeElement.firstChild;
      const {
        positionX,
        positionY
      } = this.calculatePointerMovePosition(this.zoomedImage, event.clientX, event.clientY);
      this.moveImage(positionX, positionY, boundingRect, imageElement);
    }
    changeImage(event) {
      this.mainMediaContainer.next(event.image);
    }
    /**
     * Applies the offset from touchMove or pointerMove to the image element
     *
     * @param positionX
     * @param positionY
     * @param boundingRect
     * @param imageElement
     */
    moveImage(positionX, positionY, boundingRect, imageElement) {
      const {
        x,
        y
      } = this.handleOutOfBounds(positionX, positionY, imageElement, boundingRect);
      if (imageElement) {
        this.renderer.setStyle(imageElement, 'left', x + 'px');
        this.renderer.setStyle(imageElement, 'top', y + 'px');
      }
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    /**
     * Returns click and dblclick event mapping for the given element
     *
     * @param element
     */
    clickOrDoubleClick(element) {
      return [fromEvent(element.nativeElement, 'click').pipe(switchMap(() => this.breakpointService.isUp(BREAKPOINT.md)), filter(Boolean)), fromEvent(element.nativeElement, 'dblclick').pipe(switchMap(() => this.breakpointService.isDown(BREAKPOINT.lg)), filter(Boolean))];
    }
    /**
     * Return an array of CarouselItems for the product thumbnails.
     * In case there are less then 2 thumbs, we return null.
     */
    createThumbs(product) {
      if (!product.images || !product.images.GALLERY || Array.isArray(product.images.GALLERY) && product.images.GALLERY.length < 2) {
        return [];
      }
      const images = product.images.GALLERY;
      return images.map(c => of({
        container: c
      }));
    }
    /**
     * Keeps the zoom image from leaving the bounding container
     *
     * @param positionX
     * @param positionY
     * @param imageElement
     * @param boundingRect
     */
    handleOutOfBounds(positionX, positionY, imageElement, boundingRect) {
      const paddingX = 60;
      const paddingY = 60;
      if (positionY <= -imageElement?.height + paddingY) {
        positionY = -imageElement?.height + paddingY;
      }
      if (positionY >= boundingRect?.height - paddingY) {
        positionY = boundingRect?.height - paddingY;
      }
      if (positionX <= -imageElement?.width - boundingRect?.width / 2 + paddingX) {
        positionX = -imageElement?.width - boundingRect?.width / 2 + paddingX;
      }
      if (positionX >= imageElement?.width + boundingRect?.width / 2 - paddingX) {
        positionX = imageElement?.width + boundingRect?.width / 2 - paddingX;
      }
      return {
        x: positionX,
        y: positionY
      };
    }
    /**
     * Returns the position of the image based on the cursor pointer
     *
     * @param element
     * @param clientX
     * @param clientY
     */
    calculatePointerMovePosition(element, clientX, clientY) {
      const boundingRect = element.nativeElement.getBoundingClientRect();
      const x = clientX - boundingRect.left;
      const y = clientY - boundingRect.top;
      const positionX = -x + element.nativeElement.clientWidth / 2;
      const positionY = -y + element.nativeElement.clientHeight / 2;
      return {
        positionX,
        positionY
      };
    }
    onImageLoad() {
      this.imageLoaded.next(true);
    }
    static {
      this.ɵfac = function ProductImageZoomViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomViewComponent)(i0.ɵɵdirectiveInject(i1.CurrentProductService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.BreakpointService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductImageZoomViewComponent,
        selectors: [["cx-product-image-zoom-view"]],
        viewQuery: function ProductImageZoomViewComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
            i0.ɵɵviewQuery(_c2, 5, ElementRef);
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultImage = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zoomImage = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zoomedImage = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zoomButton = _t.first);
          }
        },
        inputs: {
          galleryIndex: "galleryIndex"
        },
        standalone: false,
        decls: 3,
        vars: 5,
        consts: [["defaultImage", ""], ["zoomContainer", ""], ["zoomedImage", ""], ["zoomButton", ""], [4, "ngIf"], [3, "productImage", "thumbs$", "activeThumb"], ["class", "cx-main-image-group", 4, "ngIf"], [1, "cx-main-image-group"], [1, "cx-navigate-image"], ["class", "btn btn-link", 3, "click", 4, "ngIf"], ["class", "cx-image-container", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-link", 3, "click"], [3, "type"], [1, "cx-image-container"], ["class", "cx-default-image-zoom", 3, "container", "loaded", 4, "ngIf"], ["class", "cx-zoom-container", 4, "ngIf"], ["class", "btn btn-link cx-zoom-btn", 3, "title", "click", 4, "ngIf"], [1, "cx-default-image-zoom", 3, "loaded", "container"], [1, "cx-zoom-container"], [1, "cx-image-zoomed", 3, "mousemove", "touchmove", "touchend", "loaded", "container"], [1, "btn", "btn-link", "cx-zoom-btn", 3, "click", "title"], ["class", "cx-zoom-indicator", 3, "type", 4, "ngIf"], [1, "cx-zoom-indicator", 3, "type"], ["class", "cx-default-image-zoom", 3, "container", 4, "ngIf"], [1, "cx-default-image-zoom", 3, "container"], [1, "cx-image-zoomed", 3, "mousemove", "touchmove", "touchend", "container"]],
        template: function ProductImageZoomViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProductImageZoomViewComponent_ng_container_0_Template, 3, 3, "ng-container", 4);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "cx-product-image-zoom-thumbnails", 5);
            i0.ɵɵlistener("productImage", function ProductImageZoomViewComponent_Template_cx_product_image_zoom_thumbnails_productImage_2_listener($event) {
              return ctx.changeImage($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 3, ctx.mainImage$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("thumbs$", ctx.thumbnails$)("activeThumb", ctx.activeThumb);
          }
        },
        dependencies: [i2.NgIf, i1.IconComponent, i1.MediaComponent, i3.FeatureDirective, ProductImageZoomThumbnailsComponent, i2.AsyncPipe, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProductImageZoomViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomDialogComponent = /*#__PURE__*/(() => {
  class ProductImageZoomDialogComponent {
    handleClick(event) {
      // Close on click outside the dialog window
      if (event.target.tagName === this.el.nativeElement.tagName) {
        this.close('Cross click');
      }
    }
    constructor(launchDialogService, el) {
      this.launchDialogService = launchDialogService;
      this.el = el;
      this.iconType = ICON_TYPE;
      this.focusConfig = {
        trap: true,
        block: true,
        autofocus: 'button',
        focusOnEscape: true
      };
      useFeatureStyles('a11yCloseProductImageBtnFocus');
      useFeatureStyles('a11yExpandedFocusIndicator');
    }
    close(reason = '') {
      this.launchDialogService.closeDialog(reason);
    }
    static {
      this.ɵfac = function ProductImageZoomDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomDialogComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductImageZoomDialogComponent,
        selectors: [["cx-product-image-zoom-dialog"]],
        hostBindings: function ProductImageZoomDialogComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ProductImageZoomDialogComponent_click_HostBindingHandler($event) {
              return ctx.handleClick($event);
            });
          }
        },
        inputs: {
          galleryIndex: "galleryIndex"
        },
        standalone: false,
        decls: 11,
        vars: 12,
        consts: [["role", "dialog", 1, "modal-dialog", "modal-dialog-centered", "modal-lg", "cx-image-zoom-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-dialog-content"], [1, "modal-header", "cx-dialog-header"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "modal-body", "cx-dialog-body"], [3, "galleryIndex"]],
        template: function ProductImageZoomDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "cxTranslate");
            i0.ɵɵlistener("esc", function ProductImageZoomDialogComponent_Template_div_esc_0_listener() {
              return ctx.close("Escape clicked");
            });
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "button", 3);
            i0.ɵɵpipe(5, "cxTranslate");
            i0.ɵɵpipe(6, "cxTranslate");
            i0.ɵɵlistener("click", function ProductImageZoomDialogComponent_Template_button_click_4_listener() {
              return ctx.close("cross click");
            });
            i0.ɵɵelementStart(7, "span", 4);
            i0.ɵɵelement(8, "cx-icon", 5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 6);
            i0.ɵɵelement(10, "cx-product-image-zoom-view", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxFocus", ctx.focusConfig);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 6, "productImageZoomDialog.zoomedInImage"));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 8, "productImageZoomDialog.close"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 10, "productImageZoomDialog.close"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("type", ctx.iconType.CLOSE);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("galleryIndex", ctx.galleryIndex);
          }
        },
        dependencies: [i1.IconComponent, i1.FocusDirective, ProductImageZoomViewComponent, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProductImageZoomDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultProductImageZoomLayoutConfig = {
  launch: {
    PRODUCT_IMAGE_ZOOM: {
      inline: true,
      component: ProductImageZoomDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomTriggerComponent = /*#__PURE__*/(() => {
  class ProductImageZoomTriggerComponent {
    set expandImage(expand) {
      if (expand) {
        this.triggerZoom();
      }
    }
    constructor(launchDialogService, vcr) {
      this.launchDialogService = launchDialogService;
      this.vcr = vcr;
      this.iconType = ICON_TYPE;
      this.subscriptions = new Subscription();
      this.dialogClose = new EventEmitter();
      useFeatureStyles('a11yLinkBtnsToTertiaryBtns');
    }
    triggerZoom() {
      const component = this.launchDialogService.launch("PRODUCT_IMAGE_ZOOM" /* LAUNCH_CALLER.PRODUCT_IMAGE_ZOOM */, this.vcr);
      if (component) {
        this.subscriptions.add(combineLatest([component, this.launchDialogService.dialogClose]).pipe(tap(([comp]) => {
          if (this.galleryIndex) {
            comp.instance.galleryIndex = this.galleryIndex;
          }
        }), filter(([, close]) => Boolean(close)), tap(([comp]) => {
          this.launchDialogService.clear("PRODUCT_IMAGE_ZOOM" /* LAUNCH_CALLER.PRODUCT_IMAGE_ZOOM */);
          comp?.destroy();
          this.dialogClose.emit();
          this.expandButton.nativeElement.focus();
        })).subscribe());
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function ProductImageZoomTriggerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomTriggerComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductImageZoomTriggerComponent,
        selectors: [["cx-product-image-zoom-trigger"]],
        viewQuery: function ProductImageZoomTriggerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandButton = _t.first);
          }
        },
        inputs: {
          galleryIndex: "galleryIndex",
          expandImage: "expandImage"
        },
        outputs: {
          dialogClose: "dialogClose"
        },
        standalone: false,
        decls: 2,
        vars: 2,
        consts: [["expandButton", ""], ["class", "btn btn-tertiary", 3, "click", 4, "cxFeature"], ["class", "btn btn-link cx-action-link", 3, "click", 4, "cxFeature"], [1, "btn", "btn-tertiary", 3, "click"], [3, "type"], [1, "btn", "btn-link", "cx-action-link", 3, "click"]],
        template: function ProductImageZoomTriggerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProductImageZoomTriggerComponent_button_0_Template, 5, 4, "button", 1)(1, ProductImageZoomTriggerComponent_button_1_Template, 6, 4, "button", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxFeature", "a11yLinkBtnsToTertiaryBtns");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yLinkBtnsToTertiaryBtns");
          }
        },
        dependencies: [i1.IconComponent, i3.FeatureDirective, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProductImageZoomTriggerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomProductImagesComponent = /*#__PURE__*/(() => {
  class ProductImageZoomProductImagesComponent extends ProductImagesComponent {
    constructor(currentProductService) {
      super(currentProductService);
      this.currentProductService = currentProductService;
      this.expandImage = new BehaviorSubject(false);
      this.product$ = this.product$;
    }
    openImage(item) {
      this.mainMediaContainer.next(item);
      this.selectedIndex = this.mainMediaContainer.value?.zoom?.galleryIndex;
    }
    /**
     * Opens image zoom dialog.
     */
    triggerZoom(value) {
      this.expandImage.next(value);
    }
    static {
      this.ɵfac = function ProductImageZoomProductImagesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomProductImagesComponent)(i0.ɵɵdirectiveInject(i1.CurrentProductService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductImageZoomProductImagesComponent,
        selectors: [["cx-product-images"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 6,
        consts: [["thumb", ""], [4, "ngIf"], [3, "click", "container"], [3, "dialogClose", "expandImage", "galleryIndex"], ["role", "region", "tabindex", "-1", "class", "thumbs", "itemWidth", "120px", 3, "items", "hideIndicators", "template", 4, "ngIf"], ["role", "region", "tabindex", "-1", "itemWidth", "120px", 1, "thumbs", 3, "items", "hideIndicators", "template"], ["cxFocusableCarouselItem", "", "tabindex", "0", "format", "product", 3, "container", "is-active", "focus", 4, "cxFeature"], ["tabindex", "0", "format", "product", 3, "container", "is-active", "focus", 4, "cxFeature"], ["cxFocusableCarouselItem", "", "tabindex", "0", "format", "product", 3, "focus", "container"], ["tabindex", "0", "format", "product", 3, "focus", "container"]],
        template: function ProductImageZoomProductImagesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProductImageZoomProductImagesComponent_ng_container_0_Template, 3, 3, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, ProductImageZoomProductImagesComponent_ng_container_2_Template, 3, 3, "ng-container", 1);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵtemplate(4, ProductImageZoomProductImagesComponent_ng_template_4_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.mainImage$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.thumbs$));
          }
        },
        dependencies: [i1.CarouselComponent, i1.FocusableCarouselItemDirective, i2.NgIf, i1.MediaComponent, i3.FeatureDirective, ProductImageZoomTriggerComponent, i2.AsyncPipe, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ProductImageZoomProductImagesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomModule = /*#__PURE__*/(() => {
  class ProductImageZoomModule {
    static {
      this.ɵfac = function ProductImageZoomModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProductImageZoomModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultProductImageZoomLayoutConfig), provideDefaultConfig({
          cmsComponents: {
            ProductImagesComponent: {
              component: ProductImageZoomProductImagesComponent
            }
          }
        })],
        imports: [CarouselModule, CommonModule, I18nModule, IconModule, KeyboardFocusModule, MediaModule, OutletModule, RouterModule, FeaturesConfigModule]
      });
    }
  }
  return ProductImageZoomModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductImageZoomComponentsModule = /*#__PURE__*/(() => {
  class ProductImageZoomComponentsModule {
    static {
      this.ɵfac = function ProductImageZoomComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductImageZoomComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProductImageZoomComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ProductImageZoomModule]
      });
    }
  }
  return ProductImageZoomComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ProductImageZoomComponentsModule, ProductImageZoomDialogComponent, ProductImageZoomModule, ProductImageZoomProductImagesComponent, ProductImageZoomThumbnailsComponent, ProductImageZoomTriggerComponent, ProductImageZoomViewComponent, defaultProductImageZoomLayoutConfig };
